/**
 * 描述：客户端左侧导航
 * 日期：2017-8-22
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('resCenAppLeftModule', [])
    .directive('appLeft', ['$q', 'resourceCenterService', '$state', 'locationNodeService', '$stateParams', 'trsHttpService', function($q, resourceCenterService, $state, locationNodeService, $stateParams, trsHttpService) {
        return {
            replace: false,
            restrict: 'E',
            scope: {
                treeModel: '='
            },
            templateUrl: './networkResource/classifiedResource/app/left/left_tpl.html',
            link: function($scope, $elem, $attrs) {
                initStatus();
                initData();

                /**
                 * [stopPropagation description] 阻止冒泡
                 * @return {[type]} [description]
                 */
                $scope.stopPropagation = function(event) {
                    event.stopPropagation();
                };

                /**
                 * [selectNode description]
                 * @param {object} [node] [description] 所选节点
                 * @return {[type]} [description]
                 */
                function selectNode(node) {
                    var urlName = 'front.networksource.classifiedresource.app.resource';
                    $stateParams = {
                        acode: node.acode,
                        fcode: node.fcode,
                        is_host_site: node.is_host_site,
                        flag: node.flag,
                        media_id: node.media_id,
                        hybase_id: node.hybase_id,
                        param_data: node.param_data,
                        medianame: node.name
                    };
                    resourceCenterService.go(urlName, $stateParams);
                }
                $scope.selectNode = selectNode;

                /**
                 * [expandNode description] 展开树节点
                 * @param {object} [node] [description] 节点信息
                 * @return {[type]} [description]
                 */
                $scope.expandNode = function(node) {
                    getOtherLevels(node);
                };

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        options: {
                            nodeChildren: 'CHILDREN',
                            allowDeselect: false,
                            dirSelectable: true,
                            injectClasses: {},
                            templateUrl: '../app/components/htmlTemplates/treeTemplate.html',
                            isLeaf: function(node) {
                                return !node.url;
                            }
                        },
                        expandedNodes: []
                    };
                    $scope.data = {};
                    $scope.$on('searchNode', function(event, data) {
                        // console.log(data);
                        locationNodeService.locationBySearch(data, $scope.treeModel, function(tree, selectedNode, expandedNodes) {
                            $scope.status.selectedNode = selectedNode;
                            $scope.status.expandedNodes = expandedNodes;
                            $scope.selectNode($scope.status.selectedNode);
                        });
                    });
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    // routeMemoryLocation();
                    locationNodeService.recordRouteLocation($scope, 'app', function(tree, selectedNode, expandedNodes) {
                        $scope.status.selectedNode = selectedNode;
                        $scope.status.expandedNodes = expandedNodes;
                    }, function(tree, selectedNode, expandedNodes) {
                        $scope.status.selectedNode = selectedNode;
                        $scope.status.expandedNodes = expandedNodes;
                        selectNode(selectedNode);
                    });
                }

                /**
                 * [getSecondLevel description] 获取二级节点
                 * @param {object} [node] [description] 节点信息
                 * @return {[type]} [description]
                 */
                function getOtherLevels(node) {
                    if (!!node.CHILDREN) {return;}
                    if (!node.url) {return;}
                    var urlArray = node.url.split('/');
                    var params = {
                        typeid: urlArray[0],
                        serviceid: urlArray[1],
                        modelId: urlArray[2]
                    };
                    var paramArray = !!node.param_level ? node.param_level.split('&') : [];
                    for (var i in paramArray) {
                        var attribute = paramArray[i];
                        params[attribute] = node[attribute];
                    }
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        node.CHILDREN = data.content;
                    });
                }
            }
        };
    }]);
